<template>
    <div>
        <slot :manual-link="manualLink"></slot>
    </div>
</template>

<script>

export default {
    name: 'KSteelCodeGuide',
    computed: {
        manualLink() {
            if (this.$i18n.locale === 'ko' && this.ko_manual_url) {
                return this.ko_manual_url;
            } else if (this.$i18n.locale === 'en' && this.en_manual_url) {
                return this.en_manual_url;
            } else if (this.$i18n.locale === 'ca' && this.ca_manual_url) {
                return this.ca_manual_url;
            }
            return this.ko_manual_url;
        },
        ko_manual_url() {
            return '/document/manual/steel/2025_철강협력사_ESG_진단지표_평가기준.pdf';
        },
        en_manual_url() {
            return null;

            // return '/document/manual/hmg/2025_HMG_Supply_Chain_Assessment_System_User_Manual_Eng.pdf';

        },
        ca_manual_url() {
            return null;

            // return '/document/manual/hmg/2025_HMG_Supply_Chain_Assessment_System_User_Manual_Eng.pdf';
        },
    },
};
</script>
